import { Link } from 'react-router-dom';
import { MenuItem } from 'react-pro-sidebar';
import { Typography } from '@mui/material';

const Item = ({ title, to, icon, selected, setSelected, colors }) => {
  const handleClick = () => {
    setSelected(title);
  }
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
      }}
      onClick={handleClick}
      icon={icon}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};

export default Item;